import { canListActiveJobs, useGlobal } from "../../../../core/Global"
import Layout from "../../../../components/layouts/Layout"
import Section from "../../../../components/base/Section"
import Icon from "../../../../components/base/Icon"

/** The jobs board's views (list, calendar, map) need ListActiveJobs. */
export default function JobsBoardGuard(props: { children: JSX.Element }) {

    // Re-renders once the roles arrive with the session.
    const [global] = useGlobal()

    if (!global.user || canListActiveJobs()) return props.children

    return (
        <Layout>
            <Section>
                <div className="alert alert-warning d-flex align-items-center">
                    <Icon icon="lock" className="me-3" />
                    You don't have access to the active jobs board.
                </div>
            </Section>
        </Layout>
    )
}
